<template>
  <div class="wrap">
    <div class="mask"></div>
    <div class="keyboard">
      <div class="display">
        <p
          :class="[
            'value',
            {
              placeholder: value === '0'
            }
          ]"
        >
          {{ value === '0' ? '请输入所需数量' : value }}
        </p>
        <div class="btn-clear" @click="clear">
          <IconFont name="del_icon" color="#ccc" size="14px" />
        </div>
      </div>
      <div class="keys">
        <div class="row">
          <div class="key" @click="append('1')">1</div>
          <div class="key" @click="append('2')">2</div>
          <div class="key" @click="append('3')">3</div>
        </div>
        <div class="row">
          <div class="key" @click="append('4')">4</div>
          <div class="key" @click="append('5')">5</div>
          <div class="key" @click="append('6')">6</div>
        </div>
        <div class="row">
          <div class="key" @click="append('7')">7</div>
          <div class="key" @click="append('8')">8</div>
          <div class="key" @click="append('9')">9</div>
        </div>
        <div class="row">
          <div class="key" @click="close">取消</div>
          <div class="key" @click="append('0')">0</div>
          <div class="key" @click="confirm">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    defaultValue: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      value: `${this.defaultValue}`
    }
  },
  methods: {
    clear() {
      this.value = '0'
    },
    append(value) {
      const v = this.value + value
      if (parseInt(v) < 200) {
        this.value = v[0] === '0' ? v.slice(1) : v
      } else {
        this.$toast('购买不能大于199件')
      }
    },
    close() {
      this.$emit('close')
      document.body.removeChild(this.$el)
      this.$destroy()
    },
    confirm() {
      this.$emit('confirm', parseInt(this.value))
      document.body.removeChild(this.$el)
      this.$destroy()
    }
  }
}
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: $z-alert;

  width: 100%;
  height: 100%;

  background-color: rgba(0, 0, 0, 0.5);
}
.keyboard {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: $z-alert + 1;

  width: 100%;

  background-color: white;

  .display {
    height: 38px;
    @include flex(row, flex-start, center, nowrap);

    .value {
      padding-left: 10px;

      flex: auto;

      font-size: 16px;
      line-height: 38px;

      color: $c-text-normal;

      &.placeholder {
        color: $c-text-extra-lighter;
      }
    }

    .btn-clear {
      width: 44px;
      height: 38px;

      text-align: center;

      ::v-deep i {
        line-height: 38px;
      }
    }
  }

  .keys {
    .row {
      border-top: 1px solid $c-border-grey;
      @include flex(row, flex-start, center, nowrap);

      .key {
        flex: 1;

        font-size: 20px;
        line-height: 50px;
        text-align: center;

        color: $c-text-normal;

        &:first-child {
          border-right: 1px solid $c-border-grey;
        }

        &:last-child {
          border-left: 1px solid $c-border-grey;
        }
      }
    }
  }
}
</style>
